module.exports = __webpack_public_path__ + "img/pc_banner_sup_coupon.203525f0.webp";